// Footer.js
import React from 'react';
import './index.css';
import HeaderSocial from '../HeaderSocial';
import Resume from '../CTA';

const Footer = () => (
  <footer className="container footer_container">
    <div className="footer_content">
      <Resume />
      <p className="work">
        <HeaderSocial />
        Bye!
      </p>
    </div>
  </footer>
);

export default Footer;
